// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.oars-context-panel {
  padding: 0.5rem 1rem 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

/* Specific Skills conversation context in the three-column report panel.
   Its parent .panel-content already applies the shared inline padding
   (--app-sidebar-content-padding-inline), so the base 1rem here was doubling
   up and insetting this panel further than the feedback cards below it.
   Dropping the inline padding widens it and lines it up with them. The
   single-column drawer (.oars-sidebar-context-panel) and the Be the Client
   counsellor card (.btc-counsellor-context-panel) keep the base padding. */
.oars-report-context-panel {
  padding-left: 0;
  padding-right: 0;
}

.oars-context-body {
  font-size: 0.88rem;
  line-height: 1.65;
  color: #374151;
  padding: 0;
  white-space: pre-wrap;
  word-break: break-word;
}

.dark .oars-context-body {
  color: #d1d5db;
}

/* ── OARS Interaction Log ─────────────────────────── */

.oars-attempt-entry {
  padding: 0.65rem 0;
  border-bottom: 1px solid var(--border-color, #2d3748);
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.oars-attempt-entry:last-child {
  border-bottom: none;
}

.oars-label-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.3rem;
}

.oars-label-group-title {
  font-size: 0.67rem;
  font-weight: 600;
  color: var(--text-muted, #6b7280);
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-right: 0.15rem;
  white-space: nowrap;
}

.oars-chip {
  font-size: 0.65rem;
  font-weight: 600;
  padding: 0.12rem 0.42rem;
  border-radius: 999px;
  border: 1px solid;
  letter-spacing: 0.03em;
}

.oars-report-text {
  margin: 0;
  font-size: 0.86rem;
  line-height: 1.55;
  color: var(--text-primary, #1e293b);
  white-space: pre-wrap;
  word-break: break-word;
}

.oars-feedback-context-card {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  margin-bottom: 1.2rem;
}

.oars-report-response-box {
  max-width: 100%;
  width: fit-content;
  margin-right: auto;
  overflow: hidden;
}

.oars-report-response-scroll {
  max-height: calc(1.55em * 3);
  width: calc(100% - 0.25rem);
  margin-right: 0.25rem;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #94a3b8 transparent;
  padding-right: 0.1rem;
}

.oars-report-response-scroll .oars-report-text {
  color: inherit;
}

.oars-report-response-scroll::-webkit-scrollbar {
  width: 10px;
}

.oars-report-response-scroll::-webkit-scrollbar-track {
  background: transparent;
  margin: 0.2rem 0;
}

.oars-report-response-scroll::-webkit-scrollbar-thumb {
  background: #94a3b8;
  border-radius: 999px;
  border-left: 3px solid transparent;
  background-clip: padding-box;
}

.oars-report-feedback-card {
  border-radius: 8px;
  overflow: hidden;
}

.oars-report-feedback-content {
  min-height: 0;
}

.dark .oars-report-text {
  color: #e2e8f0;
}

.dark .oars-report-response-scroll .oars-report-text {
  color: inherit;
}

.dark .oars-report-response-scroll {
  scrollbar-color: #64748b transparent;
}

.dark .oars-report-response-scroll::-webkit-scrollbar-thumb {
  background: #64748b;
}

/* OARS action buttons */
.oars-action-dock {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  flex-shrink: 0;
  padding: 0.75rem 1rem;
  background: var(--surface-color);
  border-top: 1px solid rgba(148, 163, 184, 0.25);
}

.dark .oars-action-dock {
  background: #1c2630;
  border-top-color: rgba(75, 85, 99, 0.4);
}

@keyframes strategies-next-exercise-complete-cue {
  0% {
    box-shadow: 0 0 0 0 rgba(74, 222, 128, 0);
    text-shadow: none;
  }
  25% {
    box-shadow:
      0 0 0 4px rgba(134, 239, 172, 1),
      0 0 24px rgba(74, 222, 128, 0.95),
      0 0 42px rgba(34, 197, 94, 0.62);
    text-shadow:
      0 0 5px rgba(255, 255, 255, 1),
      0 0 12px rgba(134, 239, 172, 1),
      0 0 20px rgba(74, 222, 128, 0.9);
  }
  70% {
    box-shadow:
      0 0 0 7px rgba(134, 239, 172, 0.48),
      0 0 22px rgba(74, 222, 128, 0.58);
    text-shadow:
      0 0 4px rgba(255, 255, 255, 0.9),
      0 0 10px rgba(74, 222, 128, 0.7);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(74, 222, 128, 0);
    text-shadow: none;
  }
}

.strategies-next-exercise--complete-cue {
  animation: strategies-next-exercise-complete-cue 2s ease-out;
}

@media (prefers-reduced-motion: reduce) {
  .strategies-next-exercise--complete-cue {
    animation: none;
  }
}

.oars-action-bar {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
}

.oars-next-exercise-wrap {
  position: relative;
  width: 100%;
}

.oars-next-exercise-tooltip {
  position: absolute;
  left: 0;
  bottom: calc(100% + 0.55rem);
  transform: none;
  width: 100%;
  max-width: none;
  padding: 0.6rem 0.75rem;
  border-radius: 10px;
  border: 1px solid rgba(148, 163, 184, 0.28);
  background: rgba(255, 255, 255, 0.98);
  color: #475569;
  font-size: 0.75rem;
  line-height: 1.45;
  text-align: center;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.12);
  z-index: 3;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity 0.18s ease, visibility 0.18s ease;
}

.oars-next-exercise-wrap:hover .oars-next-exercise-tooltip {
  opacity: 1;
  visibility: visible;
}

.dark .oars-next-exercise-tooltip {
  border-color: rgba(71, 85, 105, 0.7);
  background: rgba(15, 23, 42, 0.96);
  color: rgba(226, 232, 240, 0.88);
  box-shadow: 0 14px 30px rgba(2, 6, 23, 0.35);
}

.oars-expert-response-wrap {
  display: block;
}

.oars-expert-response-wrap .oars-next-exercise-tooltip {
  left: 0;
  right: 0;
  transform: none;
  width: 100%;
  max-width: none;
  box-sizing: border-box;
  bottom: calc(100% + 0.55rem);
  z-index: 6;
}

.oars-btn {
  padding: 7px 16px;
  border-radius: 8px;
  border: 1.5px solid transparent;
  font-size: 0.82rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
  font-family: inherit;
  width: 100%;
}

.oars-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  box-shadow: none;
}

.oars-btn:disabled:hover {
  opacity: 0.45;
}

.oars-btn--selection-cue {
  border-color: #3b82f6;
  background: #dbeafe;
  color: #111827;
  box-shadow:
    0 0 0 3px rgba(59, 130, 246, 0.42),
    0 0 30px rgba(59, 130, 246, 0.82);
}

.oars-btn--secondary {
  background: transparent;
  border-color: var(--border-color, rgba(255,255,255,0.2));
  color: var(--text-secondary, #ccc);
}

.oars-btn--secondary:hover {
  border-color: var(--text-secondary, #ccc);
  color: var(--text-primary, #eee);
}

.oars-btn--secondary:disabled:hover {
  border-color: var(--border-color, rgba(255,255,255,0.2));
  color: var(--text-secondary, #ccc);
}

.oars-btn--primary {
  background: var(--accent-color, #4a9eff);
  color: #fff;
  border-color: var(--accent-color, #4a9eff);
}

.oars-btn--primary:hover {
  opacity: 0.85;
}

.oars-btn--primary:disabled:hover {
  opacity: 0.45;
}

.dark .oars-btn--primary {
  background: #2563a8;
  border-color: #2563a8;
}

.dark .oars-btn--selection-cue {
  border-color: #60a5fa;
  background: #1e3a5f;
  color: #ffffff;
  box-shadow:
    0 0 0 3px rgba(96, 165, 250, 0.3),
    0 0 28px rgba(96, 165, 250, 0.44);
}

.oars-btn--primary.oars-btn--selection-cue,
.oars-btn--secondary.oars-btn--selection-cue {
  background: var(--accent-color, #4a9eff);
  border-color: var(--accent-color, #4a9eff);
  color: #fff;
}

.dark .oars-btn--primary.oars-btn--selection-cue,
.dark .oars-btn--secondary.oars-btn--selection-cue {
  background: #2563a8;
  border-color: #2563a8;
  color: #fff;
}

.dark .oars-btn--primary:hover {
  background: #1e4f8a;
  border-color: #1e4f8a;
  opacity: 1;
}

.dark .oars-btn--secondary {
  border-color: #374151;
  color: #d1d5db;
}

.dark .oars-btn--secondary:hover {
  border-color: #9ca3af;
  color: #f9fafb;
}

.light .oars-btn--secondary {
  border-color: rgba(0,0,0,0.15);
  color: #374151;
}

.light .oars-btn--secondary:hover {
  border-color: #374151;
  color: #111827;
}

/* ── Loading dots ── */

.loading-dots {
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.loading-dots span {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--text-secondary, #6b7280);
  animation: loading-dot-bounce 1.2s ease-in-out infinite;
}

.loading-dots span:nth-child(2) { animation-delay: 0.2s; }
.loading-dots span:nth-child(3) { animation-delay: 0.4s; }

@keyframes loading-dot-bounce {
  0%, 80%, 100% { transform: translateY(0); opacity: 0.4; }
  40%            { transform: translateY(-5px); opacity: 1; }
}

/* ── Simple Reflections evaluator ── */

.sr-feedback-text {
  font-size: 0.85rem;
  line-height: 1.6;
  color: var(--text-primary, #e5e7eb);
  margin: 0;
  white-space: pre-wrap;
}

.dark .sr-feedback-text {
  color: #e5e7eb;
}

.light .sr-feedback-text {
  color: #1f2937;
}

.oars-pass-animation {
  position: relative;
  width: 139px;
  height: 149px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.oars-aimie-svg {
  width: 100%;
  height: 100%;
  overflow: visible;
  animation: oarsAimieEnter 560ms cubic-bezier(0.2, 0.8, 0.2, 1) both;
}

.oars-aimie-backdrop {
  fill: rgba(16, 185, 129, 0.12);
  stroke: rgba(16, 185, 129, 0.26);
  stroke-width: 2;
}

.oars-aimie-arc {
  stroke: #10b981;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-dasharray: 80;
  stroke-dashoffset: 80;
  opacity: 0.45;
  animation: oarsAimieArcDraw 880ms ease-out 120ms forwards;
}

.oars-aimie-arc--two {
  animation-delay: 240ms;
}

.oars-aimie-robot {
  animation: oarsAimieRobotRise 620ms cubic-bezier(0.2, 0.8, 0.2, 1) both;
  transform-box: view-box;
  transform-origin: 60px 86px;
}

.oars-aimie-head,
.oars-aimie-body,
.oars-aimie-ear,
.oars-aimie-neck,
.oars-aimie-antenna,
.oars-aimie-antenna-stem,
.oars-aimie-chest,
.oars-aimie-shoulder {
  fill: #8fa0a0;
  stroke: #1f2933;
  stroke-width: 2;
}

.oars-aimie-body,
.oars-aimie-ear,
.oars-aimie-chest,
.oars-aimie-shoulder {
  fill: #788b8b;
}

.oars-aimie-arm {
  animation: oarsAimieArmSweep 720ms cubic-bezier(0.2, 0.8, 0.2, 1) 220ms both;
  transform-box: fill-box;
}

.oars-aimie-arm--left {
  transform-origin: 34px 88px;
}

.oars-aimie-arm--right {
  transform-origin: 86px 88px;
}

.oars-aimie-arm-fill {
  fill: #788b8b;
  stroke: #1f2933;
  stroke-width: 2;
  stroke-linejoin: round;
}

.oars-aimie-antenna {
  animation: oarsAimieAntennaPop 720ms cubic-bezier(0.2, 0.8, 0.2, 1) 140ms both;
  transform-box: fill-box;
  transform-origin: center;
}

.oars-aimie-face-shine {
  stroke: rgba(255, 255, 255, 0.32);
  stroke-width: 3;
  stroke-linecap: round;
}

.oars-aimie-eye-outer {
  fill: #fef3c7;
  stroke: #1f2933;
  stroke-width: 2;
}

.oars-aimie-eye-inner {
  fill: #111827;
}

.oars-aimie-eye {
  animation: oarsAimieEyePulse 900ms ease-out 260ms both;
  transform-box: fill-box;
  transform-origin: center;
}

.oars-aimie-smile,
.oars-aimie-check,
.oars-aimie-spark {
  stroke-linecap: round;
  stroke-linejoin: round;
}

.oars-aimie-smile {
  stroke: #111827;
  stroke-width: 2.4;
}

.oars-aimie-check {
  stroke: #10b981;
  stroke-width: 3;
  stroke-dasharray: 18;
  stroke-dashoffset: 18;
  animation: oarsAimieCheckDraw 520ms ease-out 760ms forwards;
}

.oars-aimie-spark {
  stroke: #10b981;
  stroke-width: 2.4;
  opacity: 0;
  transform-box: fill-box;
  transform-origin: center;
  animation: oarsAimieSpark 1080ms ease-out 520ms forwards;
}

.oars-aimie-spark--two {
  animation-delay: 640ms;
}

.oars-aimie-spark--three {
  animation-delay: 720ms;
}

.oars-aimie-banner {
  animation: oarsAimieBannerRise 620ms cubic-bezier(0.2, 0.8, 0.2, 1) 360ms both;
  transform-box: fill-box;
  transform-origin: center;
}

.oars-aimie-banner-shape {
  fill: #fef3c7;
  stroke: #1f2933;
  stroke-width: 2.4;
  stroke-linejoin: round;
}

.oars-aimie-banner-text {
  fill: #111827;
  font-size: 16px;
  font-weight: 800;
  letter-spacing: 0;
  text-anchor: middle;
  dominant-baseline: middle;
}

.dark .oars-aimie-backdrop {
  fill: rgba(52, 211, 153, 0.12);
  stroke: rgba(52, 211, 153, 0.3);
}

.dark .oars-aimie-arc,
.dark .oars-aimie-spark,
.dark .oars-aimie-check {
  stroke: #34d399;
}

.dark .oars-aimie-head,
.dark .oars-aimie-body,
.dark .oars-aimie-ear,
.dark .oars-aimie-neck,
.dark .oars-aimie-antenna,
.dark .oars-aimie-antenna-stem,
.dark .oars-aimie-chest,
.dark .oars-aimie-shoulder {
  fill: #7b8d8d;
  stroke: #e5e7eb;
}

.dark .oars-aimie-body,
.dark .oars-aimie-ear,
.dark .oars-aimie-chest,
.dark .oars-aimie-shoulder {
  fill: #667979;
}

.dark .oars-aimie-arm-fill {
  fill: #667979;
  stroke: #e5e7eb;
}

.dark .oars-aimie-eye-outer {
  fill: #fef3c7;
  stroke: #e5e7eb;
}

.dark .oars-aimie-smile {
  stroke: #111827;
}

.dark .oars-aimie-banner-shape {
  fill: #fef3c7;
  stroke: #e5e7eb;
}

@keyframes oarsAimieEnter {
  0% { opacity: 0; transform: translateY(10px) scale(0.9); }
  65% { opacity: 1; transform: translateY(-2px) scale(1.03); }
  100% { opacity: 1; transform: translateY(0) scale(1); }
}

@keyframes oarsAimieArcDraw {
  to { stroke-dashoffset: 0; }
}

@keyframes oarsAimieRobotRise {
  0% { opacity: 0; transform: translateY(12px) scale(0.95); }
  100% { opacity: 1; transform: translateY(0) scale(1); }
}

@keyframes oarsAimieAntennaPop {
  0% { opacity: 0; transform: translateY(6px) scale(0.72); }
  60% { opacity: 1; transform: translateY(-2px) scale(1.12); }
  100% { opacity: 1; transform: translateY(0) scale(1); }
}

@keyframes oarsAimieArmSweep {
  0% { opacity: 0; transform: translateY(8px) scale(0.9); }
  100% { opacity: 1; transform: translateY(0) scale(1); }
}

@keyframes oarsAimieEyePulse {
  0% { transform: scale(0.82); }
  45% { transform: scale(1.12); }
  100% { transform: scale(1); }
}

@keyframes oarsAimieCheckDraw {
  to { stroke-dashoffset: 0; }
}

@keyframes oarsAimieBannerRise {
  0% { opacity: 0; transform: translateY(9px) scale(0.96); }
  100% { opacity: 1; transform: translateY(0) scale(1); }
}

@keyframes oarsAimieSpark {
  0% { opacity: 0; transform: scale(0.4) rotate(0deg); }
  35% { opacity: 1; }
  100% { opacity: 0; transform: scale(1.35) rotate(18deg); }
}

@media (prefers-reduced-motion: reduce) {
  .oars-aimie-svg,
  .oars-aimie-arc,
  .oars-aimie-robot,
  .oars-aimie-antenna,
  .oars-aimie-arm,
  .oars-aimie-eye,
  .oars-aimie-check,
  .oars-aimie-banner,
  .oars-aimie-spark {
    animation: none;
  }

  .oars-aimie-arc,
  .oars-aimie-check {
    stroke-dashoffset: 0;
  }

  .oars-aimie-spark {
    opacity: 0.75;
  }
}

.oars-pass-title {
  margin: 0;
  font-size: 1.15rem;
  font-weight: 700;
  line-height: 1.3;
  color: var(--text-primary, #e5e7eb);
}

.light .oars-pass-title {
  color: #111827;
}
`, "",{"version":3,"sources":["webpack://./src/components/report/ReportOarsPanel.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;;;;;;2EAM2E;AAC3E;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,UAAU;EACV,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA,wDAAwD;;AAExD;EACE,kBAAkB;EAClB,qDAAqD;EACrD,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,oBAAoB;EACpB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,mCAAmC;EACnC,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,qBAAqB;EACrB,gBAAgB;EAChB,qBAAqB;EACrB,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,cAAc;EACd,qBAAqB;EACrB,gCAAgC;EAChC,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE;IACE,yCAAyC;IACzC,iBAAiB;EACnB;EACA;IACE;;;sCAGkC;IAClC;;;sCAGkC;EACpC;EACA;IACE;;uCAEmC;IACnC;;sCAEkC;EACpC;EACA;IACE,yCAAyC;IACzC,iBAAiB;EACnB;AACF;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,4BAA4B;EAC5B,eAAe;EACf,WAAW;EACX,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;EACrC,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,8CAA8C;EAC9C,UAAU;EACV,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB,qDAAqD;AACvD;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,kCAAkC;EAClC,gCAAgC;EAChC,4CAA4C;AAC9C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,QAAQ;EACR,eAAe;EACf,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,4BAA4B;EAC5B,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd;;qCAEmC;AACrC;;AAEA;EACE,uBAAuB;EACvB,wDAAwD;EACxD,kCAAkC;AACpC;;AAEA;EACE,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA;EACE,wDAAwD;EACxD,kCAAkC;AACpC;;AAEA;EACE,wCAAwC;EACxC,WAAW;EACX,0CAA0C;AAC5C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd;;qCAEmC;AACrC;;AAEA;;EAEE,wCAAwC;EACxC,0CAA0C;EAC1C,WAAW;AACb;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA,uBAAuB;;AAEvB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,0CAA0C;EAC1C,uDAAuD;AACzD;;AAEA,kCAAkC,qBAAqB,EAAE;AACzD,kCAAkC,qBAAqB,EAAE;;AAEzD;EACE,gBAAgB,wBAAwB,EAAE,YAAY,EAAE;EACxD,iBAAiB,2BAA2B,EAAE,UAAU,EAAE;AAC5D;;AAEA,uCAAuC;;AAEvC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;EACnC,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mEAAmE;AACrE;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,yDAAyD;AAC3D;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uEAAuE;EACvE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;;;;;;;;EAQE,aAAa;EACb,eAAe;EACf,eAAe;AACjB;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;EACE,4EAA4E;EAC5E,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,8EAA8E;EAC9E,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sDAAsD;EACtD,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;;;EAGE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,2DAA2D;AAC7D;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,uBAAuB;EACvB,wBAAwB;EACxB,wDAAwD;AAC1D;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,8EAA8E;EAC9E,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;;;EAGE,eAAe;AACjB;;AAEA;;;;;;;;EAQE,aAAa;EACb,eAAe;AACjB;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,KAAK,UAAU,EAAE,sCAAsC,EAAE;EACzD,MAAM,UAAU,EAAE,uCAAuC,EAAE;EAC3D,OAAO,UAAU,EAAE,iCAAiC,EAAE;AACxD;;AAEA;EACE,KAAK,oBAAoB,EAAE;AAC7B;;AAEA;EACE,KAAK,UAAU,EAAE,uCAAuC,EAAE;EAC1D,OAAO,UAAU,EAAE,iCAAiC,EAAE;AACxD;;AAEA;EACE,KAAK,UAAU,EAAE,sCAAsC,EAAE;EACzD,MAAM,UAAU,EAAE,uCAAuC,EAAE;EAC3D,OAAO,UAAU,EAAE,iCAAiC,EAAE;AACxD;;AAEA;EACE,KAAK,UAAU,EAAE,qCAAqC,EAAE;EACxD,OAAO,UAAU,EAAE,iCAAiC,EAAE;AACxD;;AAEA;EACE,KAAK,sBAAsB,EAAE;EAC7B,MAAM,sBAAsB,EAAE;EAC9B,OAAO,mBAAmB,EAAE;AAC9B;;AAEA;EACE,KAAK,oBAAoB,EAAE;AAC7B;;AAEA;EACE,KAAK,UAAU,EAAE,sCAAsC,EAAE;EACzD,OAAO,UAAU,EAAE,iCAAiC,EAAE;AACxD;;AAEA;EACE,KAAK,UAAU,EAAE,kCAAkC,EAAE;EACrD,MAAM,UAAU,EAAE;EAClB,OAAO,UAAU,EAAE,oCAAoC,EAAE;AAC3D;;AAEA;EACE;;;;;;;;;IASE,eAAe;EACjB;;EAEA;;IAEE,oBAAoB;EACtB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".oars-context-panel {\n  padding: 0.5rem 1rem 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n/* Specific Skills conversation context in the three-column report panel.\n   Its parent .panel-content already applies the shared inline padding\n   (--app-sidebar-content-padding-inline), so the base 1rem here was doubling\n   up and insetting this panel further than the feedback cards below it.\n   Dropping the inline padding widens it and lines it up with them. The\n   single-column drawer (.oars-sidebar-context-panel) and the Be the Client\n   counsellor card (.btc-counsellor-context-panel) keep the base padding. */\n.oars-report-context-panel {\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.oars-context-body {\n  font-size: 0.88rem;\n  line-height: 1.65;\n  color: #374151;\n  padding: 0;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.dark .oars-context-body {\n  color: #d1d5db;\n}\n\n/* ── OARS Interaction Log ─────────────────────────── */\n\n.oars-attempt-entry {\n  padding: 0.65rem 0;\n  border-bottom: 1px solid var(--border-color, #2d3748);\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.oars-attempt-entry:last-child {\n  border-bottom: none;\n}\n\n.oars-label-row {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.3rem;\n}\n\n.oars-label-group-title {\n  font-size: 0.67rem;\n  font-weight: 600;\n  color: var(--text-muted, #6b7280);\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  margin-right: 0.15rem;\n  white-space: nowrap;\n}\n\n.oars-chip {\n  font-size: 0.65rem;\n  font-weight: 600;\n  padding: 0.12rem 0.42rem;\n  border-radius: 999px;\n  border: 1px solid;\n  letter-spacing: 0.03em;\n}\n\n.oars-report-text {\n  margin: 0;\n  font-size: 0.86rem;\n  line-height: 1.55;\n  color: var(--text-primary, #1e293b);\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.oars-feedback-context-card {\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n  margin-bottom: 1.2rem;\n}\n\n.oars-report-response-box {\n  max-width: 100%;\n  width: fit-content;\n  margin-right: auto;\n  overflow: hidden;\n}\n\n.oars-report-response-scroll {\n  max-height: calc(1.55em * 3);\n  width: calc(100% - 0.25rem);\n  margin-right: 0.25rem;\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: #94a3b8 transparent;\n  padding-right: 0.1rem;\n}\n\n.oars-report-response-scroll .oars-report-text {\n  color: inherit;\n}\n\n.oars-report-response-scroll::-webkit-scrollbar {\n  width: 10px;\n}\n\n.oars-report-response-scroll::-webkit-scrollbar-track {\n  background: transparent;\n  margin: 0.2rem 0;\n}\n\n.oars-report-response-scroll::-webkit-scrollbar-thumb {\n  background: #94a3b8;\n  border-radius: 999px;\n  border-left: 3px solid transparent;\n  background-clip: padding-box;\n}\n\n.oars-report-feedback-card {\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.oars-report-feedback-content {\n  min-height: 0;\n}\n\n.dark .oars-report-text {\n  color: #e2e8f0;\n}\n\n.dark .oars-report-response-scroll .oars-report-text {\n  color: inherit;\n}\n\n.dark .oars-report-response-scroll {\n  scrollbar-color: #64748b transparent;\n}\n\n.dark .oars-report-response-scroll::-webkit-scrollbar-thumb {\n  background: #64748b;\n}\n\n/* OARS action buttons */\n.oars-action-dock {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  flex-shrink: 0;\n  padding: 0.75rem 1rem;\n  background: var(--surface-color);\n  border-top: 1px solid rgba(148, 163, 184, 0.25);\n}\n\n.dark .oars-action-dock {\n  background: #1c2630;\n  border-top-color: rgba(75, 85, 99, 0.4);\n}\n\n@keyframes strategies-next-exercise-complete-cue {\n  0% {\n    box-shadow: 0 0 0 0 rgba(74, 222, 128, 0);\n    text-shadow: none;\n  }\n  25% {\n    box-shadow:\n      0 0 0 4px rgba(134, 239, 172, 1),\n      0 0 24px rgba(74, 222, 128, 0.95),\n      0 0 42px rgba(34, 197, 94, 0.62);\n    text-shadow:\n      0 0 5px rgba(255, 255, 255, 1),\n      0 0 12px rgba(134, 239, 172, 1),\n      0 0 20px rgba(74, 222, 128, 0.9);\n  }\n  70% {\n    box-shadow:\n      0 0 0 7px rgba(134, 239, 172, 0.48),\n      0 0 22px rgba(74, 222, 128, 0.58);\n    text-shadow:\n      0 0 4px rgba(255, 255, 255, 0.9),\n      0 0 10px rgba(74, 222, 128, 0.7);\n  }\n  100% {\n    box-shadow: 0 0 0 0 rgba(74, 222, 128, 0);\n    text-shadow: none;\n  }\n}\n\n.strategies-next-exercise--complete-cue {\n  animation: strategies-next-exercise-complete-cue 2s ease-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .strategies-next-exercise--complete-cue {\n    animation: none;\n  }\n}\n\n.oars-action-bar {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  align-items: center;\n}\n\n.oars-next-exercise-wrap {\n  position: relative;\n  width: 100%;\n}\n\n.oars-next-exercise-tooltip {\n  position: absolute;\n  left: 0;\n  bottom: calc(100% + 0.55rem);\n  transform: none;\n  width: 100%;\n  max-width: none;\n  padding: 0.6rem 0.75rem;\n  border-radius: 10px;\n  border: 1px solid rgba(148, 163, 184, 0.28);\n  background: rgba(255, 255, 255, 0.98);\n  color: #475569;\n  font-size: 0.75rem;\n  line-height: 1.45;\n  text-align: center;\n  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.12);\n  z-index: 3;\n  opacity: 0;\n  visibility: hidden;\n  pointer-events: none;\n  transition: opacity 0.18s ease, visibility 0.18s ease;\n}\n\n.oars-next-exercise-wrap:hover .oars-next-exercise-tooltip {\n  opacity: 1;\n  visibility: visible;\n}\n\n.dark .oars-next-exercise-tooltip {\n  border-color: rgba(71, 85, 105, 0.7);\n  background: rgba(15, 23, 42, 0.96);\n  color: rgba(226, 232, 240, 0.88);\n  box-shadow: 0 14px 30px rgba(2, 6, 23, 0.35);\n}\n\n.oars-expert-response-wrap {\n  display: block;\n}\n\n.oars-expert-response-wrap .oars-next-exercise-tooltip {\n  left: 0;\n  right: 0;\n  transform: none;\n  width: 100%;\n  max-width: none;\n  box-sizing: border-box;\n  bottom: calc(100% + 0.55rem);\n  z-index: 6;\n}\n\n.oars-btn {\n  padding: 7px 16px;\n  border-radius: 8px;\n  border: 1.5px solid transparent;\n  font-size: 0.82rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  font-family: inherit;\n  width: 100%;\n}\n\n.oars-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n.oars-btn:disabled:hover {\n  opacity: 0.45;\n}\n\n.oars-btn--selection-cue {\n  border-color: #3b82f6;\n  background: #dbeafe;\n  color: #111827;\n  box-shadow:\n    0 0 0 3px rgba(59, 130, 246, 0.42),\n    0 0 30px rgba(59, 130, 246, 0.82);\n}\n\n.oars-btn--secondary {\n  background: transparent;\n  border-color: var(--border-color, rgba(255,255,255,0.2));\n  color: var(--text-secondary, #ccc);\n}\n\n.oars-btn--secondary:hover {\n  border-color: var(--text-secondary, #ccc);\n  color: var(--text-primary, #eee);\n}\n\n.oars-btn--secondary:disabled:hover {\n  border-color: var(--border-color, rgba(255,255,255,0.2));\n  color: var(--text-secondary, #ccc);\n}\n\n.oars-btn--primary {\n  background: var(--accent-color, #4a9eff);\n  color: #fff;\n  border-color: var(--accent-color, #4a9eff);\n}\n\n.oars-btn--primary:hover {\n  opacity: 0.85;\n}\n\n.oars-btn--primary:disabled:hover {\n  opacity: 0.45;\n}\n\n.dark .oars-btn--primary {\n  background: #2563a8;\n  border-color: #2563a8;\n}\n\n.dark .oars-btn--selection-cue {\n  border-color: #60a5fa;\n  background: #1e3a5f;\n  color: #ffffff;\n  box-shadow:\n    0 0 0 3px rgba(96, 165, 250, 0.3),\n    0 0 28px rgba(96, 165, 250, 0.44);\n}\n\n.oars-btn--primary.oars-btn--selection-cue,\n.oars-btn--secondary.oars-btn--selection-cue {\n  background: var(--accent-color, #4a9eff);\n  border-color: var(--accent-color, #4a9eff);\n  color: #fff;\n}\n\n.dark .oars-btn--primary.oars-btn--selection-cue,\n.dark .oars-btn--secondary.oars-btn--selection-cue {\n  background: #2563a8;\n  border-color: #2563a8;\n  color: #fff;\n}\n\n.dark .oars-btn--primary:hover {\n  background: #1e4f8a;\n  border-color: #1e4f8a;\n  opacity: 1;\n}\n\n.dark .oars-btn--secondary {\n  border-color: #374151;\n  color: #d1d5db;\n}\n\n.dark .oars-btn--secondary:hover {\n  border-color: #9ca3af;\n  color: #f9fafb;\n}\n\n.light .oars-btn--secondary {\n  border-color: rgba(0,0,0,0.15);\n  color: #374151;\n}\n\n.light .oars-btn--secondary:hover {\n  border-color: #374151;\n  color: #111827;\n}\n\n/* ── Loading dots ── */\n\n.loading-dots {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.loading-dots span {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: var(--text-secondary, #6b7280);\n  animation: loading-dot-bounce 1.2s ease-in-out infinite;\n}\n\n.loading-dots span:nth-child(2) { animation-delay: 0.2s; }\n.loading-dots span:nth-child(3) { animation-delay: 0.4s; }\n\n@keyframes loading-dot-bounce {\n  0%, 80%, 100% { transform: translateY(0); opacity: 0.4; }\n  40%            { transform: translateY(-5px); opacity: 1; }\n}\n\n/* ── Simple Reflections evaluator ── */\n\n.sr-feedback-text {\n  font-size: 0.85rem;\n  line-height: 1.6;\n  color: var(--text-primary, #e5e7eb);\n  margin: 0;\n  white-space: pre-wrap;\n}\n\n.dark .sr-feedback-text {\n  color: #e5e7eb;\n}\n\n.light .sr-feedback-text {\n  color: #1f2937;\n}\n\n.oars-pass-animation {\n  position: relative;\n  width: 139px;\n  height: 149px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.oars-aimie-svg {\n  width: 100%;\n  height: 100%;\n  overflow: visible;\n  animation: oarsAimieEnter 560ms cubic-bezier(0.2, 0.8, 0.2, 1) both;\n}\n\n.oars-aimie-backdrop {\n  fill: rgba(16, 185, 129, 0.12);\n  stroke: rgba(16, 185, 129, 0.26);\n  stroke-width: 2;\n}\n\n.oars-aimie-arc {\n  stroke: #10b981;\n  stroke-width: 2;\n  stroke-linecap: round;\n  stroke-dasharray: 80;\n  stroke-dashoffset: 80;\n  opacity: 0.45;\n  animation: oarsAimieArcDraw 880ms ease-out 120ms forwards;\n}\n\n.oars-aimie-arc--two {\n  animation-delay: 240ms;\n}\n\n.oars-aimie-robot {\n  animation: oarsAimieRobotRise 620ms cubic-bezier(0.2, 0.8, 0.2, 1) both;\n  transform-box: view-box;\n  transform-origin: 60px 86px;\n}\n\n.oars-aimie-head,\n.oars-aimie-body,\n.oars-aimie-ear,\n.oars-aimie-neck,\n.oars-aimie-antenna,\n.oars-aimie-antenna-stem,\n.oars-aimie-chest,\n.oars-aimie-shoulder {\n  fill: #8fa0a0;\n  stroke: #1f2933;\n  stroke-width: 2;\n}\n\n.oars-aimie-body,\n.oars-aimie-ear,\n.oars-aimie-chest,\n.oars-aimie-shoulder {\n  fill: #788b8b;\n}\n\n.oars-aimie-arm {\n  animation: oarsAimieArmSweep 720ms cubic-bezier(0.2, 0.8, 0.2, 1) 220ms both;\n  transform-box: fill-box;\n}\n\n.oars-aimie-arm--left {\n  transform-origin: 34px 88px;\n}\n\n.oars-aimie-arm--right {\n  transform-origin: 86px 88px;\n}\n\n.oars-aimie-arm-fill {\n  fill: #788b8b;\n  stroke: #1f2933;\n  stroke-width: 2;\n  stroke-linejoin: round;\n}\n\n.oars-aimie-antenna {\n  animation: oarsAimieAntennaPop 720ms cubic-bezier(0.2, 0.8, 0.2, 1) 140ms both;\n  transform-box: fill-box;\n  transform-origin: center;\n}\n\n.oars-aimie-face-shine {\n  stroke: rgba(255, 255, 255, 0.32);\n  stroke-width: 3;\n  stroke-linecap: round;\n}\n\n.oars-aimie-eye-outer {\n  fill: #fef3c7;\n  stroke: #1f2933;\n  stroke-width: 2;\n}\n\n.oars-aimie-eye-inner {\n  fill: #111827;\n}\n\n.oars-aimie-eye {\n  animation: oarsAimieEyePulse 900ms ease-out 260ms both;\n  transform-box: fill-box;\n  transform-origin: center;\n}\n\n.oars-aimie-smile,\n.oars-aimie-check,\n.oars-aimie-spark {\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n.oars-aimie-smile {\n  stroke: #111827;\n  stroke-width: 2.4;\n}\n\n.oars-aimie-check {\n  stroke: #10b981;\n  stroke-width: 3;\n  stroke-dasharray: 18;\n  stroke-dashoffset: 18;\n  animation: oarsAimieCheckDraw 520ms ease-out 760ms forwards;\n}\n\n.oars-aimie-spark {\n  stroke: #10b981;\n  stroke-width: 2.4;\n  opacity: 0;\n  transform-box: fill-box;\n  transform-origin: center;\n  animation: oarsAimieSpark 1080ms ease-out 520ms forwards;\n}\n\n.oars-aimie-spark--two {\n  animation-delay: 640ms;\n}\n\n.oars-aimie-spark--three {\n  animation-delay: 720ms;\n}\n\n.oars-aimie-banner {\n  animation: oarsAimieBannerRise 620ms cubic-bezier(0.2, 0.8, 0.2, 1) 360ms both;\n  transform-box: fill-box;\n  transform-origin: center;\n}\n\n.oars-aimie-banner-shape {\n  fill: #fef3c7;\n  stroke: #1f2933;\n  stroke-width: 2.4;\n  stroke-linejoin: round;\n}\n\n.oars-aimie-banner-text {\n  fill: #111827;\n  font-size: 16px;\n  font-weight: 800;\n  letter-spacing: 0;\n  text-anchor: middle;\n  dominant-baseline: middle;\n}\n\n.dark .oars-aimie-backdrop {\n  fill: rgba(52, 211, 153, 0.12);\n  stroke: rgba(52, 211, 153, 0.3);\n}\n\n.dark .oars-aimie-arc,\n.dark .oars-aimie-spark,\n.dark .oars-aimie-check {\n  stroke: #34d399;\n}\n\n.dark .oars-aimie-head,\n.dark .oars-aimie-body,\n.dark .oars-aimie-ear,\n.dark .oars-aimie-neck,\n.dark .oars-aimie-antenna,\n.dark .oars-aimie-antenna-stem,\n.dark .oars-aimie-chest,\n.dark .oars-aimie-shoulder {\n  fill: #7b8d8d;\n  stroke: #e5e7eb;\n}\n\n.dark .oars-aimie-body,\n.dark .oars-aimie-ear,\n.dark .oars-aimie-chest,\n.dark .oars-aimie-shoulder {\n  fill: #667979;\n}\n\n.dark .oars-aimie-arm-fill {\n  fill: #667979;\n  stroke: #e5e7eb;\n}\n\n.dark .oars-aimie-eye-outer {\n  fill: #fef3c7;\n  stroke: #e5e7eb;\n}\n\n.dark .oars-aimie-smile {\n  stroke: #111827;\n}\n\n.dark .oars-aimie-banner-shape {\n  fill: #fef3c7;\n  stroke: #e5e7eb;\n}\n\n@keyframes oarsAimieEnter {\n  0% { opacity: 0; transform: translateY(10px) scale(0.9); }\n  65% { opacity: 1; transform: translateY(-2px) scale(1.03); }\n  100% { opacity: 1; transform: translateY(0) scale(1); }\n}\n\n@keyframes oarsAimieArcDraw {\n  to { stroke-dashoffset: 0; }\n}\n\n@keyframes oarsAimieRobotRise {\n  0% { opacity: 0; transform: translateY(12px) scale(0.95); }\n  100% { opacity: 1; transform: translateY(0) scale(1); }\n}\n\n@keyframes oarsAimieAntennaPop {\n  0% { opacity: 0; transform: translateY(6px) scale(0.72); }\n  60% { opacity: 1; transform: translateY(-2px) scale(1.12); }\n  100% { opacity: 1; transform: translateY(0) scale(1); }\n}\n\n@keyframes oarsAimieArmSweep {\n  0% { opacity: 0; transform: translateY(8px) scale(0.9); }\n  100% { opacity: 1; transform: translateY(0) scale(1); }\n}\n\n@keyframes oarsAimieEyePulse {\n  0% { transform: scale(0.82); }\n  45% { transform: scale(1.12); }\n  100% { transform: scale(1); }\n}\n\n@keyframes oarsAimieCheckDraw {\n  to { stroke-dashoffset: 0; }\n}\n\n@keyframes oarsAimieBannerRise {\n  0% { opacity: 0; transform: translateY(9px) scale(0.96); }\n  100% { opacity: 1; transform: translateY(0) scale(1); }\n}\n\n@keyframes oarsAimieSpark {\n  0% { opacity: 0; transform: scale(0.4) rotate(0deg); }\n  35% { opacity: 1; }\n  100% { opacity: 0; transform: scale(1.35) rotate(18deg); }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .oars-aimie-svg,\n  .oars-aimie-arc,\n  .oars-aimie-robot,\n  .oars-aimie-antenna,\n  .oars-aimie-arm,\n  .oars-aimie-eye,\n  .oars-aimie-check,\n  .oars-aimie-banner,\n  .oars-aimie-spark {\n    animation: none;\n  }\n\n  .oars-aimie-arc,\n  .oars-aimie-check {\n    stroke-dashoffset: 0;\n  }\n\n  .oars-aimie-spark {\n    opacity: 0.75;\n  }\n}\n\n.oars-pass-title {\n  margin: 0;\n  font-size: 1.15rem;\n  font-weight: 700;\n  line-height: 1.3;\n  color: var(--text-primary, #e5e7eb);\n}\n\n.light .oars-pass-title {\n  color: #111827;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
